import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';

/**
 * 主页STORE
 */
export default {
  state: {
    searchKeywordList: [], //随机获取关键词列表
    lastSearchList: [], //最近搜索列表
    shareGoodsLists: [],
    pageNo: 1,
    lastPage: 1,
  },
  actions: {

    /*获取首页幻灯*/
    getHomeSlide({ commit }, appType = 4) {
      return http.post({
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    /*获取品牌分类*/
    getBrandCates({ commit }, data) {
      return http.post({
        fn: 'mallsale.navBarHandler.getBrandCates',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    /*获取广告banner*/
    getAdBanners({ commit }, appType = 4) {
      return http.post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    /*获取系列推荐商品*/
    getRecomGoods({ commit }) {
      return http.post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    /*获取VR 展示广告*/
    getVrBanner({ commit }, appType = 4) {
      return http.post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    /*获取精品推荐商品*/
    getBoutiqueGoods({ commit }) {
      return http.post({
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    /*获取最新消息发布*/
    getNewMessages({ commit }) {
      return http.post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    /*获取商品楼层*/
    getHomeFloorInfos({ commit }, appType = 4) {
      return http.post({
        fn: 'mallsale.floorHandler.getHomeFloorInfos',
        param: [appType]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*获取商品楼层*/
    getHomeFloorInfos({ commit }, appType = 4) {
      return http.post({
        fn: 'mallsale.floorHandler.getHomeFloorInfos',
        param: [appType]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //查询子品牌首页mallsale.storeHandler.getStoreBaseInfo;
    getStoreBaseInfo({ commit }, storeId) {
      return http.post({
        fn: 'mallsale.storeHandler.getStoreBaseInfo',
        param: [storeId]
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //获取店铺的banner  mallsale.storeHandler.getStoreBanner
    getStoreBanner({ commit }, storeId) {
      return http.post({
        fn: 'mallsale.storeHandler.getStoreBanner',
        param: storeId
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //获取促销广告 mallsale.storeHandler.getStorePromotions
    getStorePromotions({ commit }, storeId) {
      return http.post({
        fn: 'mallsale.storeHandler.getStorePromotions',
        param: storeId
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //获取楼层数据mallsale.storeHandler.getStoreFloorInfo
    getStoreFloorInfo({ commit }, storeId) {
      return http.post({
        fn: 'mallsale.storeHandler.getStoreFloorInfo',
        param: storeId
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },



    //随机获取一组搜索关键字
    getHotSearch({ commit }) {
      return http.post({
        fn: 'mallsale.searchHandler.getHotSearch',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          let data = result.target.target;
          commit(types.SEARCH_KEYWORD_LIST, data);
          return Promise.resolve(data);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    //22.1.首页-获取2条最新的（晒家）晒商品分享
    getMainShareGoods({ commit }) {
      return http.post({
        fn: 'mallsale.shareHandler.getMainShareGoods',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //22.2.分页查询 （晒家）晒商品分享
    pageShareGoods({ commit },data) {
      commit(types.PAGENO,data[1]);
      return http.post({
        fn: 'mallsale.shareHandler.pageShareGoods',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          commit(types.SHARE_GOODS_LISTS,result.target.target.result);
          commit(types.LASTPAGE,result.target.target.lastPageNo);
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //22.5.装修资讯 获取资讯内容
    getShareInfoContent({ commit },shareId) {
      return http.post({
        fn: 'mallsale.shareHandler.getShareInfoContent',
        param: shareId
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    //添加最近搜索
    addLastSearch({ commit }, keyword) {
      commit(types.LASTTEST_SEARCH_LIST, keyword);
    },

    //清除最近搜索
    clearLastSearch({ commit }) {
      commit(types.CLEAR_LASTTEST_SEARCH_LIST);
    },

  },
  /*8.2.分页查询会员订单*/
  /*  pageMemOrder({ commit }, data) {
      return http.jsonCall({
        fn: 'mallsale.memOrderHandler.pageMemOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target.result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
  */
  mutations: {
    [types.SEARCH_KEYWORD_LIST](state, data) {
      state.searchKeywordList = data;
      util.storage.local.set('searchKeywordList', data);
    },
    [types.LASTTEST_SEARCH_LIST](state, keyword) {
      state.lastSearchList = util.storage.local.get('lastSearchList') || [];
      if (state.lastSearchList && state.lastSearchList.length) {
        state.lastSearchList = state.lastSearchList.filter(item => {
          return item != keyword;
        })
      }
      if (state.lastSearchList && state.lastSearchList.length > 5) {
        state.lastSearchList.pop();
      }
      state.lastSearchList.splice(0, 0, keyword);
      util.storage.local.set('lastSearchList', state.lastSearchList);
    },
    [types.CLEAR_LASTTEST_SEARCH_LIST](state) {
      state.lastSearchList = [];
      util.storage.local.set('lastSearchList', []);
    },
    [types.SHARE_GOODS_LISTS](state,data){
      if(state.pageNo == 1){
        state.shareGoodsLists = [];
      }
      state.shareGoodsLists = state.shareGoodsLists.concat(data);
    },
    [types.PAGENO](state,data){
      state.pageNo = data;
    },
    [types.LASTPAGE](state,data){
      state.lastPage = data;
    }
  },
  getters: {
    searchKeywordList: state => {
      if (!state.searchKeywordList || !state.searchKeywordList.length) {
        return util.storage.local.get('searchKeywordList');
      }
      return state.searchKeywordList;
    },
    lastSearchList: state => {
      if (!state.lastSearchList || !state.lastSearchList.length) {
        return util.storage.local.get('lastSearchList');
      }
      return state.lastSearchList;
    },
    shareGoodsLists: state => {
      return state.shareGoodsLists;
    },
    pageNo: state => {
      return state.pageNo;
    },
    lastPage: state => {
      return state.lastPage;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/home/index.js